module.exports = window["redfoxThankYou"]["utils"];